export default {
  nav: {
    brandProducts: 'Productos de Positive', discover: 'Descubrir', allProducts: 'Todos los productos',
    otherProducts: 'Otros productos: {count}',
    connectedApps: 'Apps conectadas', currentProduct: 'Estás en {product}',
    openApp: 'Abrir {product} en una pestaña nueva', discoverProduct: 'Descubrir {product}',
  },
  actions: {
    tryFree: 'Probar gratis', discover: 'Descubrir', discoverProduct: 'Descubrir {product}',
    backToCatalog: 'Volver a todos los productos',
    signIn: 'Inicia sesión', close: 'Cerrar',
  },
  agent: {
    useAssistant: 'Usar en tu asistente de IA', title: 'Usa {product} en tu asistente de IA',
    description: 'Conecta tu asistente a {product} mediante su servidor MCP.',
    other: 'Otro',
    copyPrompt: 'Copiar prompt',
    copyDone: 'Copiado', copyRetry: 'Reintentar',
    connectTitle: 'Elige tu asistente', connect: 'Conectar', availableFor: 'Disponible para {product}',
    connectionHint: 'Es posible que tengas que iniciar sesión y autorizar el acceso.',
    permissions: 'Tu asistente solo accede a los datos y acciones que autorices.',
    copy: 'Copiar el prompt para conectar tu agente a {product}',
    copied: 'Prompt copiado. Pégalo en tu agente.', copyError: 'No se pudo copiar el prompt. Inténtalo de nuevo.',
  },
  catalog: {
    title: 'Descubre los productos de Positive', description: 'Herramientas que complementan {product}.',
    descriptionDefault: 'Herramientas para tus equipos de marketing y ventas.', empty: 'No hay productos por descubrir.',
  },
  product: { featuresTitle: 'Lo que puedes hacer con {product}' },
  status: { current: 'App actual', connected: 'App conectada' },
  accessibility: { openMenu: 'Abrir la navegación de productos', newTab: 'Se abre en una pestaña nueva' },
  categories: { emailSignatures: 'Firmas de correo', emailing: 'Email marketing', seo: 'SEO & GEO', socialMedia: 'Redes sociales', sales: 'Ventas' },
  products: {
    signitic: {
      tagline: 'Gestión de firmas de correo',
      description: 'Centraliza todas las firmas de correo y conviértelas en un canal de marketing.',
      features: ['Firmas uniformes en toda la empresa', 'Campañas de banners en cada correo', 'Análisis de clics y alcance'],
    },
    user: {
      tagline: 'Email marketing e interacción con clientes',
      description: 'Automatización, CRM y chat en vivo para interactuar con tus contactos en el momento adecuado.',
      features: ['Recorridos automatizados de correo y SMS', 'CRM con contactos y oportunidades', 'Chat en vivo en tu sitio web'],
    },
    surfer: {
      tagline: 'Optimización de contenido SEO y GEO',
      description: 'Escribe contenido que se posicione en Google y sea citado por los asistentes de IA.',
      features: ['Briefs de contenido para posicionarte en Google', 'Citas en ChatGPT y en las respuestas de IA', 'Redacción de artículos con IA'],
    },
    iconosquare: {
      tagline: 'Gestión y análisis de redes sociales',
      description: 'Programa, responde y mide el rendimiento de todas tus redes sociales desde una sola plataforma.',
      features: ['Programación de publicaciones en cada red', 'Una bandeja de entrada para comentarios y mensajes privados', 'Análisis e informes'],
    },
    humanlinker: {
      tagline: 'Copiloto de ventas con IA',
      description: 'Contacta con cada cliente potencial de forma personalizada y convierte las conversaciones en ventas.',
      features: ['Recomendaciones de clientes potenciales con IA', 'Secuencias de prospección personalizadas', 'Preparación de reuniones en un clic'],
    },
    ubic: {
      tagline: 'Marcador paralelo para equipos de ventas',
      description: 'Un marcador paralelo que permite a los equipos de ventas contactar con más clientes potenciales en menos tiempo.',
      features: ['Llama a varios clientes potenciales a la vez', 'Solo recibes las llamadas atendidas', 'Sincronización con tu CRM'],
    },
    nocrm: {
      tagline: 'Gestión de clientes potenciales para vendedores',
      description: 'Sigue cada cliente potencial desde el primer contacto hasta el cierre, sin la complejidad de un CRM.',
      features: ['Todos los clientes potenciales en un mismo pipeline', 'Recordatorios para no perder ninguna oportunidad', 'Aplicación móvil para trabajar sobre el terreno'],
    },
  },
};
